import React, { Fragment } from 'react';
import { TERRAIN_INFO_KEYS } from '../../constants';
import EditButton from '../../NewEditButton';
import LightboxContainer from '../../../Lightbox';
import isEmpty from 'lodash/isEmpty';

import { componentNames as editorNames } from '../../TrekOverviewModal';
import config from '../../../../config';

function TerrainInfoComp({ fieldKey, title, value, openLightbox }) {
  function handleClick() {
    openLightbox({ images: [`${config.RESOURCE_URL}/${value}`] });
  }

  function doesValueExist(value) {
    if (value) {
      if (typeof value === 'string') return value.length > 0;
      if (typeof value === 'object' || Array.isArray(value)) {
        if (value.km === 0 || value.meters === 0) return false;
        return !isEmpty(value);
      }
    }
  }

  function decideClassName(value) {
    if (doesValueExist(value)) return 'label-val';
    return 'error';
  }

  const terrainInfoValue = {
    difficulty_level: () => value,
    highest_altitude: () =>
      value && value.meters
        ? `${Number(value.meters).toLocaleString()} meters`
        : 'Not available',
    total_length: () =>
      value && value.km ? `${Number(value.km).toLocaleString()} km` : 'Not available',
    start_location: () => value,
    finish_location: () => value,
    permits: () => (doesValueExist(value) ? value.join(',') : 'Not available'),
    best_seasons: () => (doesValueExist(value) ? value.join(',') : 'Not available'),
    elevation_profile: function elevation_profile() {
      return (
        <Fragment>
          <a onClick={handleClick}>Click To Open</a>
          <LightboxContainer />
        </Fragment>
      );
    },
  };
  return (
    <li>
      <div className="label">{title}</div>
      <div className={decideClassName(value)}>
        {value ? terrainInfoValue[fieldKey]() : 'Not available'}
      </div>
    </li>
  );
}

export default function TerrainInfoViewer({
  terrain_information,
  quick_facts,
  elevation_profile,
  openLightbox,
}) {
  const combinedData = {
    ...terrain_information,
    ...quick_facts,
    elevation_profile,
  };
  return (
    <div className="white-panel">
      <h2>
        QUICK FACTS
        <EditButton editorName={editorNames.TerrainInfoEditor} openModal={false} />
      </h2>
      <ul className="overview-info-list clearfix">
        {TERRAIN_INFO_KEYS.map(info => (
          <TerrainInfoComp
            key={info.key}
            fieldKey={info.key}
            title={info.title}
            value={combinedData[info.key]}
            openLightbox={openLightbox}
          />
        ))}
      </ul>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/TrekDetail/Viewers/TerrainInfo/TerrainInfoViewer.jsx